import { AxiosError } from 'axios'
import { UseMutationOptions, useMutation, useQueryClient } from 'react-query'

import { projectsApi } from '../projects.api'
import { projectKeys } from '../projects.constants'
import { useLocale } from '@plandi/common'

export const useMutationSendMessageProjectChat = (
  chatId?: number,
  options?: UseMutationOptions<unknown, AxiosError, string>
) => {
  const queryClient = useQueryClient()
  const locale = useLocale()

  const mutation = useMutation(
    async (message) => {
      if (chatId) {
        return projectsApi.sendMessageProjectChat(
          chatId,
          {
            content: message
          },
          locale
        )
      }
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries([
          projectKeys.chat(chatId as number),
          locale
        ])

        options?.onSuccess?.(data, variables, context)
      }
    }
  )

  return mutation
}
